export default function removeQueryParameters(url) {
  const parts = url.split(/\?(.+)/);

  if (parts.length === 3) {
    return parts[0];
  } else {
    return url;
  }
}
